// extracted by mini-css-extract-plugin
module.exports = {"background":"MenuBackground--background--N3_ol","background_logo":"MenuBackground--background_logo--rw2_u"};